export function getCssToken(varName: string, fallbackHex: string): string {
  if (typeof window === 'undefined' || !window.getComputedStyle) return fallbackHex;
  const style = getComputedStyle(document.documentElement);
  if (!style?.getPropertyValue) return fallbackHex;
  const raw = (style.getPropertyValue(varName) || '').trim();
  if (!raw) return fallbackHex;
  if (raw.includes(' ')) {
    const hex = raw
      .split(/\s+/)
      .map((n) => Number(n).toString(16).padStart(2, '0'))
      .join('');
    if (hex.length === 6) return `#${hex}`;
  }
  return raw.startsWith('#') ? raw : fallbackHex;
}
